"use strict";

import _toConsumableArray from "@babel/runtime-corejs3/helpers/toConsumableArray";
var _ViewerFleetCompaniesAsManagerList_ViewerFleetCompanies, _Heading, _Heading2;
import "core-js/modules/es.array.reduce.js";
import { CDN, FLEET_PORTAL_URL } from '@autoguru/global-configs';
import { Heading, Box, Inline, Stack } from '@autoguru/overdrive';
import { Picture } from '@autoguru/picture';
import { graphql } from 'react-relay';
import { useFragment } from 'react-relay/hooks';
import * as styles from './ViewerFleetCompaniesAsManagerList.css';
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
const shortCodeAG = 'AG';
const RenderFleetCompany = ({
  slug,
  name
}) => /*#__PURE__*/_jsx(Box, {
  as: "a",
  href: `${FLEET_PORTAL_URL}/${slug}/booking`,
  padding: "6",
  borderColour: "gray",
  borderRadius: "md",
  borderWidth: "2",
  className: styles.btnItem,
  "data-fleet": slug,
  children: /*#__PURE__*/_jsx(Picture, {
    backgroundColor: "transparent",
    width: "auto",
    height: 32,
    aspectRatio: 1,
    altText: `${name} logo`,
    src: `${CDN}/images/fleet-providers/${slug}/logo.svg`
  })
});
export const ViewerFleetCompaniesAsManagerList = ({
  fleetCompanies: fleetCompaniesRef
}) => {
  const fleetCompanies = useFragment(_ViewerFleetCompaniesAsManagerList_ViewerFleetCompanies !== void 0 ? _ViewerFleetCompaniesAsManagerList_ViewerFleetCompanies : _ViewerFleetCompaniesAsManagerList_ViewerFleetCompanies = require("../../relay/__generated__/ViewerFleetCompaniesAsManagerList_ViewerFleetCompanies.graphql"), fleetCompaniesRef);
  const {
    FMOFleetCompanies,
    AGFleetCompanies
  } = fleetCompanies.reduce((acc, fmoCompany) => {
    var _fmoCompany$node$cont;
    if (((_fmoCompany$node$cont = fmoCompany.node.contract) === null || _fmoCompany$node$cont === void 0 ? void 0 : _fmoCompany$node$cont.shortCode) === shortCodeAG) {
      acc.AGFleetCompanies = [].concat(_toConsumableArray(acc.AGFleetCompanies), [fmoCompany]);
    } else {
      acc.FMOFleetCompanies = [].concat(_toConsumableArray(acc.FMOFleetCompanies), [fmoCompany]);
    }
    return acc;
  }, {
    FMOFleetCompanies: [],
    AGFleetCompanies: []
  });
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [FMOFleetCompanies.length > 0 && /*#__PURE__*/_jsx(Box, {
      marginBottom: "8",
      children: /*#__PURE__*/_jsxs(Stack, {
        space: "4",
        children: [_Heading || (_Heading = /*#__PURE__*/_jsx(Heading, {
          as: "h2",
          children: "FMOs"
        })), /*#__PURE__*/_jsx(Inline, {
          space: "3",
          alignY: "center",
          alignX: "center",
          children: FMOFleetCompanies.map(({
            node
          }) => /*#__PURE__*/_jsx(RenderFleetCompany, {
            slug: node.slug,
            name: node.name
          }, node.slug))
        })]
      })
    }), AGFleetCompanies.length > 0 && /*#__PURE__*/_jsxs(Stack, {
      space: "4",
      children: [_Heading2 || (_Heading2 = /*#__PURE__*/_jsx(Heading, {
        as: "h2",
        children: "AutoGuru Fleets"
      })), /*#__PURE__*/_jsx(Inline, {
        space: "3",
        alignY: "center",
        alignX: "center",
        children: AGFleetCompanies.map(({
          node
        }) => /*#__PURE__*/_jsx(RenderFleetCompany, {
          slug: node.slug,
          name: node.name
        }, node.slug))
      })]
    })]
  });
};
export default ViewerFleetCompaniesAsManagerList;